import React, { FC, ReactNode } from "react";

type AbsoluteProps = {
  children: ReactNode;
  left?: number;
  right?: number;
  top?: number;
  bottom?: number;
};

export const Absolute: FC<AbsoluteProps> = ({
  children,
  left,
  right,
  top,
  bottom,
}) => {
  return (
    <div style={{ position: "absolute", left, right, top, bottom, zIndex: 1 }}>
      {children}
    </div>
  );
};
